import { render, staticRenderFns } from "./copyMoveSettingsDialog.vue?vue&type=template&id=06af68e4&scoped=true"
import script from "./copyMoveSettingsDialog.vue?vue&type=script&lang=js"
export * from "./copyMoveSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./copyMoveSettingsDialog.vue?vue&type=style&index=0&id=06af68e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af68e4",
  null
  
)

export default component.exports